import { z } from 'zod';
import { DraftNodeEnvelopeSchema } from '../../entities/process-draft';
/**
 * Mode-switch endpoint: move the record from `steps` into `draftAssignments`
 * while preserving stashed task content so the user can flip back without
 * losing work. The kind-swap surfaces in the response envelope as the node
 * under its NEW kind (`'assignment'`) — never in `deletedNodeIds`.
 */ export const convertStepToAssignmentContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/steps/:stepId/convert-to-assignment',
    description: 'Move an existing draft step into the draft assignments collection; task content is stashed for a round-trip back.',
    requestSchema: z.object({}),
    responseSchema: DraftNodeEnvelopeSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Step has no upstream input',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft step not found'
        }
    }
};

//# sourceMappingURL=convert-draft-step-to-assignment.contract.js.map